import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';

import config from 'config';

import './mapbanner.scss';
const mapMarker = require('./../../../images/map_marker.png');
const bwMapMarker = require('./../../../images/bw_map_marker.png');

class MapBanner extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentWidth: null,
      latitude: null,
      longitude: null,
    };
    
    this.setMapCenter = this.setMapCenter.bind(this);
  }

  setMapCenter() {
    if(this.state.currentWidth != window.innerWidth) {
      this.setState({ currentWidth: window.innerWidth, latitude: this.props.hotel.apiData.lat, longitude: this.props.hotel.apiData.lon });
    }
  };

  componentWillMount() {
    window.addEventListener('resize', this.setMapCenter);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setMapCenter);
  }

  render() {

    const googleMapsApiKey = config.google.maps.apiKey;
    let googleMapsApiUrl = "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places";
    if(googleMapsApiKey) {
      googleMapsApiUrl += `&key=${googleMapsApiKey}`;
    }

    const MyMapComponent = withScriptjs(withGoogleMap((props) =>
      <GoogleMap
        defaultZoom={this.props.zoom || 14}
        defaultCenter={this.props.hotel.loading ? null : { lat: this.props.hotel.apiData.lat, lng: this.props.hotel.apiData.lon }}>
        {
          this.props.hotel.loading ?
          null :
          (
            <Marker 
              position={{ lat: this.props.hotel.apiData.lat, lng: this.props.hotel.apiData.lon }} 
              enableRetinaIcons
              icon={{ url: bwMapMarker }}
            />
          )
        }
        {
          this.props.showPoi ? 
          this.props.events.map((event, index) => {
            return(
              <Marker 
                key={event.id}
                position={{ lat: event.latitude, lng: event.longitude }}
                enableRetinaIcons
                icon={{ url: mapMarker }}
              />
            );
          }) : null
        }
        {
          this.props.showPoi ? 
          this.props.attractions.map((attraction, index) => {
            return(
              <Marker 
                key={attraction.place_id}
                position={{ lat: attraction.latitude, lng: attraction.longitude }} 
                enableRetinaIcons
                icon={{ url: mapMarker }}
              />
            );
          }) : null
        }
      </GoogleMap>
    ));

    return (
      <Row className="shared-mapbanner-component">

        <div className="shared-mapbanner-component__overlay hidden-xs">
          <h5>{this.props.header}</h5>
          <h3><strong>{this.props.title}</strong></h3>
          <p>{this.props.text}</p>
        </div>

        <MyMapComponent
          isMarkerShown
          googleMapURL={googleMapsApiUrl}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `256px` }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </Row>
    );
  }
}

MapBanner.displayName = 'PagesSharedMapBanner';
MapBanner.propTypes = {};
MapBanner.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      hotel: state.hotel,
      events: state.eventsCategory.apiData || [],
      attractions: state.attractions.apiData || []
  }
};

export default connect(mapStateToProps)(MapBanner);



// WEBPACK FOOTER //
// ./components/pages/shared/MapBanner.js